import * as React from "react";
const SvgRadioDefault = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#A6A6A6"
      fillRule="evenodd"
      d="M12 21.7c5.357 0 9.7-4.343 9.7-9.7S17.357 2.3 12 2.3 2.3 6.643 2.3 12s4.343 9.7 9.7 9.7m0 1.3c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgRadioDefault;
